export const formatUrl = (url) => {
  // Check if the URL starts with http:// or https://
  if (!/^https?:\/\//i.test(url)) {
    // If not, prepend http://
    return `http://${url}`;
  }
  return url;
};
